import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ButtonSize, ButtonVariant, ButtonComponent } from '@/app/shared/components/ui/button';
import { BaseDialogComponent, DialogComponentsModule } from '@/app/shared/components/ui/dialog';

type ConfirmDialogType = 'success' | 'warning' | 'error';

interface ConfirmDialogButtonProps {
  label?: string;
  size?: ButtonSize;
  variant?: ButtonVariant;
}

export interface ConfirmDialogData {
  type: ConfirmDialogType;
  title: string;
  message?: string;
  accept?: () => void;
  reject?: () => void;
  acceptVisible?: boolean;
  rejectVisible?: boolean;
  acceptButtonProps?: ConfirmDialogButtonProps;
  rejectButtonProps?: ConfirmDialogButtonProps;
}

@Component({
  selector: 'app-confirm-dialog',
  imports: [DialogComponentsModule, ButtonComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent extends BaseDialogComponent<ConfirmDialogData, boolean> {
  readonly iconByType: Record<ConfirmDialogType, string> = {
    success: '/assets/icons/confirmation-success.svg',
    warning: '/assets/icons/confirmation.svg',
    error: '/assets/icons/confirmation-error.svg',
  };

  acceptVisible: boolean;

  rejectVisible: boolean;

  constructor() {
    super();
    this.dialogRef.updateSize('420px');

    this.acceptVisible = this.data.acceptVisible ?? true;
    this.rejectVisible = this.data.rejectVisible ?? true;
  }

  reject() {
    if (this.data.reject) {
      this.data.reject();
    }
    this.dialogRef.close(false);
  }

  accept() {
    if (this.data.accept) {
      this.data.accept();
    }
    this.dialogRef.close(true);
  }
}
